import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ideabehind() {
  return (
    <section className="idea_behind p-100 text_color">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="idea_img">
              <StaticImage
                src="../../../images/case-studies/parcheesi/idea.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={537}
                height={650}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h1>
              The Idea Behind <span>Parcheesi Cash</span>
            </h1>
            <p>
              The client wanted to create a perfect mix of both the Spanish and
              the Indian versions of the game. They had a vision to completely
              eradicate the predictability factor and enhance the AI features of
              the game. Games like Parcheesi Cash have been on the market for a
              long time. However, there are certain features in the Parcheesi
              Cash that make it a one-of-a-kind experience. The six-player slot,
              improved AI, and fascinating screenplay is among those, to name a
              few.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ideabehind;
